import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormSetup, NotificationAlert, WdxSize } from '@wdx/shared/utils';

import { Icon, IconStyle, Severity } from '@wdx/shared/utils';
import { POPOVER_OPEN_DELAY } from '../../../constants/popover.constants';

/**
 * @deprecated This component as been deprecated and replaced by `WdxButtonDirective` -> `button[wdxIconButton]` | `a[wdxIconButton]`
 */
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'atom-icon-button',
    templateUrl: './atom-icon-button.component.html',
    host: { class: 'd-block position-relative' },
    standalone: false,
})
export class AtomIconButtonComponent {
    @Input() btnClass = 'btn-outline-primary'; // classes to apply directly to button
    @Input() disabled: boolean;
    @Input() icon: Icon | string;
    @Input() altText: string;
    @Input() tooltip?: string;
    @Input() notification: NotificationAlert;
    @Input() size: WdxSize = 'md';
    @Input() cySelector?: string;
    @Input() formSetup: FormSetup;
    @Input() iconStyle = IconStyle.Light;

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onClick = new EventEmitter<MouseEvent>();

    readonly NOTIFICATION_SEVERITY = Severity;
    readonly POPOVER_OPEN_DELAY = POPOVER_OPEN_DELAY;

    onIconButtonClicked($event: MouseEvent): void {
        this.onClick.emit($event);
    }
}
